var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-settings-overlay"},[_c('section',{staticClass:"tabs"},[_c('ul',[_c('li',[_vm._v("Tab 1")]),_c('li',[_vm._v("Tab 2")]),_c('li',[_vm._v("Tab 3")])])]),_c('section',{staticClass:"content"},[_vm._v("Contnet goes here")])])
}]

export { render, staticRenderFns }